import React, { useState, useEffect } from 'react';
import api from '../api';
import { useToast } from '../Toast';

export default function DepartmentsPage() {
  const [departments, setDepartments] = useState([]);
  const [allDepts, setAllDepts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editDept, setEditDept] = useState(null);
  const [accessModal, setAccessModal] = useState(null);
  const [accessUsers, setAccessUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [form, setForm] = useState({ name: '', parent_id: '' });
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  useEffect(() => { load(); }, []);
  async function load() {
    const [flat, tree] = await Promise.all([api.get('/departments/flat').then(r => r.data), api.get('/departments').then(r => r.data)]);
    setAllDepts(flat); setDepartments(tree);
    api.get('/auth/users').then(r => setAllUsers(r.data)).catch(() => {});
  }
  function openNew() { setEditDept(null); setForm({ name: '', parent_id: '' }); setShowModal(true); }
  function openEdit(d) { setEditDept(d); setForm({ name: d.name, parent_id: d.parent_id || '' }); setShowModal(true); }
  async function openAccess(d) { const r = await api.get(`/departments/${d.id}/access`); setAccessUsers(r.data.map(u => u.id)); setAccessModal(d); }

  async function handleSave(e) {
    e.preventDefault(); setSaving(true);
    try {
      if (editDept) { await api.put(`/departments/${editDept.id}`, form); toast('Dział zaktualizowany'); }
      else { await api.post('/departments', form); toast('Dział dodany'); }
      setShowModal(false); load();
    } catch (err) { toast(err.response?.data?.error || 'Błąd', 'error'); }
    finally { setSaving(false); }
  }
  async function handleDelete(id) { if (!window.confirm('Usunąć dział?')) return; await api.delete(`/departments/${id}`); toast('Dział usunięty'); load(); }
  async function saveAccess() { await api.post(`/departments/${accessModal.id}/access`, { user_ids: accessUsers }); toast('Dostępy zaktualizowane'); setAccessModal(null); }
  function toggleAccess(uid) { setAccessUsers(prev => prev.includes(uid) ? prev.filter(u => u !== uid) : [...prev, uid]); }

  function renderDepts(nodes, level = 0) {
    return nodes.map(d => (
      <React.Fragment key={d.id}>
        <tr>
          <td><span style={{ paddingLeft: level * 20, display: 'flex', alignItems: 'center', gap: 6 }}>{level > 0 && <span style={{ color: 'var(--gray-300)' }}>└</span>}{d.name}</span></td>
          <td style={{ color: 'var(--gray-400)', fontSize: 12.5 }}>{allDepts.find(p => p.id === d.parent_id)?.name || '—'}</td>
          <td><div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}><button className="btn btn-secondary btn-sm" onClick={() => openAccess(d)}>Dostępy</button><button className="btn btn-secondary btn-sm" onClick={() => openEdit(d)}>Edytuj</button><button className="btn btn-danger btn-sm" onClick={() => handleDelete(d.id)}>Usuń</button></div></td>
        </tr>
        {d.children?.length > 0 && renderDepts(d.children, level + 1)}
      </React.Fragment>
    ));
  }

  return (
    <div>
      <div className="page-header"><h1 className="page-title" style={{ margin: 0 }}>Działy</h1><button className="btn btn-primary" onClick={openNew}>+ Dodaj dział</button></div>
      <div className="card" style={{ padding: 0, overflow: 'hidden' }}><table><thead><tr><th>Nazwa</th><th>Dział nadrzędny</th><th></th></tr></thead><tbody>{renderDepts(departments)}</tbody></table></div>
      {showModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setShowModal(false)}>
          <div className="modal">
            <div className="modal-header"><span className="modal-title">{editDept ? 'Edytuj dział' : 'Nowy dział'}</span><button className="btn-icon" onClick={() => setShowModal(false)}>✕</button></div>
            <form onSubmit={handleSave}>
              <div className="modal-body">
                <div className="form-group"><label className="form-label">Nazwa działu *</label><input className="form-input" value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} required /></div>
                <div className="form-group"><label className="form-label">Dział nadrzędny</label><select className="form-select" value={form.parent_id} onChange={e => setForm(f => ({ ...f, parent_id: e.target.value }))}><option value="">— brak (dział główny) —</option>{allDepts.filter(d => d.id !== editDept?.id).map(d => <option key={d.id} value={d.id}>{d.name}</option>)}</select></div>
              </div>
              <div className="modal-footer"><button className="btn btn-secondary" type="button" onClick={() => setShowModal(false)}>Anuluj</button><button className="btn btn-primary" type="submit" disabled={saving}>{saving ? 'Zapisywanie...' : 'Zapisz'}</button></div>
            </form>
          </div>
        </div>
      )}
      {accessModal && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setAccessModal(null)}>
          <div className="modal">
            <div className="modal-header"><span className="modal-title">Dostępy: {accessModal.name}</span><button className="btn-icon" onClick={() => setAccessModal(null)}>✕</button></div>
            <div className="modal-body">
              <p style={{ fontSize: 13, color: 'var(--gray-500)', marginBottom: 12 }}>Zaznacz użytkowników z dostępem do tego działu:</p>
              {allUsers.filter(u => u.role === 'employee').map(u => (
                <label key={u.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', cursor: 'pointer', borderBottom: '1px solid var(--gray-100)' }}>
                  <input type="checkbox" checked={accessUsers.includes(u.id)} onChange={() => toggleAccess(u.id)} /><span style={{ flex: 1 }}>{u.name}</span><span style={{ fontSize: 12, color: 'var(--gray-400)' }}>{u.email}</span>
                </label>
              ))}
              {allUsers.filter(u => u.role === 'employee').length === 0 && <p style={{ color: 'var(--gray-400)', fontSize: 13 }}>Brak pracowników do przypisania</p>}
            </div>
            <div className="modal-footer"><button className="btn btn-secondary" onClick={() => setAccessModal(null)}>Anuluj</button><button className="btn btn-primary" onClick={saveAccess}>Zapisz dostępy</button></div>
          </div>
        </div>
      )}
    </div>
  );
}
